// extracted by mini-css-extract-plugin
module.exports = {"container":"article-heading-module--container--2fWtj","excerpt":"article-heading-module--excerpt--3vRa9"};